import { PolicyUnit, PolicyUsage } from "@covertree/new-business-graphql";
import { MineSubsidenceOption } from "./option";

const getMineSubsidenceOption = (unit: Omit<PolicyUnit, "pricing">) => {
  const {
    usage,
    address: { state },
  } = unit;

  if (usage === PolicyUsage.Owner && state === "IN") {
    return MineSubsidenceOption.IndianaOwner;
  }

  if (state === "IN") {
    return MineSubsidenceOption.Indiana;
  }

  if (state === "IL") {
    return MineSubsidenceOption.Illinois;
  }
  return MineSubsidenceOption.Default;
};

export { getMineSubsidenceOption };
